'use es6';

import { connect } from 'react-redux';
import PurchaseButton from '../components/PurchaseButton';
import { purchaseGoodWithPaypal, purchaseGoodWithStripe, reinstallGood, triggerPurchaseErrorModalOpening } from '../actions/GoodsActions';
import { getHasEmailAccess, getHasInstallAccess, getIsCustomer, getIsTrialPortal, getHasContentAccess, getHasRequiredMarketingHubSubscription, getHasRequiredEmailSubscription } from '../selectors/auth';
import { getIsEmailGood, getIsGoodProvider, getIsRefunded } from '../selectors/goodDetails';
import withUsageTracking from './hocs/withUsageTracking';
import { compose } from 'redux';

var mapStateToProps = function mapStateToProps(state) {
  return {
    goodId: state.goodDetails.get('goodId'),
    goodName: state.goodDetails.get('goodName'),
    goodSubType: state.goodDetails.get('subType'),
    goodType: state.goodDetails.get('type'),
    hasContentAccess: getHasContentAccess(state),
    hasInstallAccess: getHasInstallAccess(state),
    hasEmailAccess: getHasEmailAccess(state),
    hasRequiredEmailSubscription: getHasRequiredEmailSubscription(state),
    hasRequiredMarketingHubSubscription: getHasRequiredMarketingHubSubscription(state),
    isCustomer: getIsCustomer(state),
    isGoodProvider: getIsGoodProvider(state),
    isEmailGood: getIsEmailGood(state),
    isTrial: getIsTrialPortal(state),
    isFree: state.goodDetails.get('isFree'),
    isPurchased: !!state.goodDetails.get('transactionId'),
    isRefunded: getIsRefunded(state),
    newVersionAvailable: state.goodDetails.get('newVersionAvailable'),
    payWithStripe: state.goodDetails.get('stripeProvider'),
    price: state.goodDetails.get('price')
  };
};

var mapDispatchToProps = {
  purchaseGoodWithPaypal: purchaseGoodWithPaypal,
  purchaseGoodWithStripe: purchaseGoodWithStripe,
  reinstallGood: reinstallGood,
  triggerPurchaseErrorModalOpening: triggerPurchaseErrorModalOpening
};
export default compose(withUsageTracking(), connect(mapStateToProps, mapDispatchToProps))(PurchaseButton);